import React from "react";
import "./Hero.scss";
import Portrait from "./Portrait/Portrait";
import Persona from "./Persona/Persona";
import Overlay from "./Overlay/Overlay";

const Hero = () => {
  return (
    <div className="Hero">
      <Portrait />
      <Overlay />
      <Persona />
    </div>
  );
};

export default Hero;
